import { ApiClient } from "../../api/apiClient";
import { CherryPayApi } from "../../api/models";

export interface NotificationFormProps {
  apiClient: ApiClient;
  businessId: string;
  /** Hub SuperAdmin: may save/schedule with empty PassUpdateMessage after confirming silent pass update */
  allowSilentEmptyPassUpdate: boolean;
  notification?: CherryPayApi.CherryPassNotificationSchedule | null;
  notificationName: string | null;
  onCancel: () => void;
  onSuccess: (
    notification: CherryPayApi.CherryPassNotificationSchedule,
    isEditing: boolean
  ) => void;
  onFailure: (message: string, isEditing: boolean) => void;
}

export type FilterMode = "segment" | "manualFilter" | null;

export interface NotificationFormValues {
  displayName: string;
  passUpdateMessage: string;
  timeZoneId: string | null;
  sendDateTime: Date | null;
  endDateTime: Date | null;
  memberFilterQuery: string;
  memberFilterSegment: CherryPayApi.MemberFilterSegmentIdentifier | null;
  filterMode: FilterMode;
  stopSendingOption: "anytime" | "specific";
  stopSendingTimeValue: number;
  stopSendingTimeUnit: "minutes" | "hours" | "custom";
  stopSendingCustomUnit: "minutes" | "hours";
  stopSendingCustomValue: number;
  isScheduleRequested?: boolean; // Track if schedule was requested
  locationMessageOverrides: Record<string, string>;
}

export interface StopSendingOption {
  value: string;
  label: string;
  minutes?: number;
  hours?: number;
}

export const stopSendingOptions: StopSendingOption[] = [
  { value: "5min", label: "5 minutes", minutes: 5 },
  { value: "15min", label: "15 minutes", minutes: 15 },
  { value: "30min", label: "30 minutes", minutes: 30 },
  { value: "1hour", label: "1 hour", hours: 1 },
  { value: "3hours", label: "3 hours", hours: 3 },
  { value: "6hours", label: "6 hours", hours: 6 },
  { value: "12hours", label: "12 hours", hours: 12 },
  { value: "custom", label: "Custom" },
];
